export default function EmailIcon({
                                      size = 40,
                                  }: {
    size?: number

}) {
    return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 40 40" fill="none">
        <rect width="40" height="40" rx="8" fill="url(#paint0_linear_124_10994)"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M30.8867 12.5448C30.9585 12.4862 31 12.3997 31 12.3085C31 12.1381 30.8581 12 30.683 12H9.49205C9.2203 12 9 12.2144 9 12.4789C9 12.6212 9.06508 12.7562 9.17759 12.8472L19.5082 21.2008C19.7333 21.3828 20.06 21.3821 20.2842 21.199L30.8867 12.5448ZM9.99246 15.2938C9.59792 14.9748 9 15.2478 9 15.7471V27.9107C9 28.2362 9.27109 28.5 9.6055 28.5H30.3945C30.7289 28.5 31 28.2362 31 27.9107V15.5103C31 15.0098 30.3994 14.7372 30.0054 15.0588L20.353 22.9375C20.0642 23.1732 19.7375 23.1739 19.5124 22.9919L9.99246 15.2938Z"
              fill="white"/>
        <defs>
            <linearGradient id="paint0_linear_124_10994" x1="20" y1="0" x2="20" y2="40" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFB950"/>
                <stop offset="0.475" stopColor="#FF7A60"/>
                <stop offset="1" stopColor="#FF3C4A"/>
            </linearGradient>
        </defs>
    </svg>
}